import React from 'react';
import classNames from 'classnames';

import config from 'config';
import { urls } from 'constants/jump';

import * as mixpanel from 'services/mixPanel';
import { mixPanelEvents } from 'constants/mixPanel';

interface DashboardCardProps {
  title?: string;
  className?: string;
  children?: React.ReactNode;
}

interface DashboardLinkedCardProps extends DashboardCardProps {
  link: string;
  target?: React.HTMLAttributeAnchorTarget;
}

export default function DashboardCard({ title = '', className, children }: DashboardCardProps) {
  return (
    <div className={classNames('full-scope-card', 'dashboard__card', className)}>
      {title && <div className="dashboard__title">{title}</div>}
      <div className="dashboard__content">{children}</div>
    </div>
  );
}

export function DashboardLinkedCard({ link, target = '_self', ...props }: DashboardLinkedCardProps) {
  const { myKpis, askShareForm } = mixPanelEvents.view;

  const getMixpanelEvent = (href: string) => {
    if (href === urls.KPI_VIEW) {
      return myKpis;
    }

    if (href === config.askUsAnythingForm) {
      return askShareForm;
    }

    return null;
  };

  return (
    <a
      href={link}
      target={target}
      className="dashboard__card--link"
      onClick={() => mixpanel.trackEvent(getMixpanelEvent(link))}
    >
      <DashboardCard className="dashboard__card--linked" {...props} />
    </a>
  );
}
